import '../styles/app.css'
import '../guest/guest.css'
import { mount } from 'svelte'
import CodeEntry from '../guest/CodeEntry.svelte'
import { blockInstallPrompt } from '../lib/platform'
import { isTvBrowser } from '../wall/tvdevice'
import { Updater } from '../lib/updater'
import { BUILD } from '../lib/version'

// A television that opens the home page is taken to the page that pairs it; nobody types a code with a remote.
if (isTvBrowser(navigator.userAgent)) location.replace('/tv')

blockInstallPrompt()
// The code page holds nothing worth keeping, so it may reload whenever a newer build is out.
new Updater({ build: BUILD, isSafe: () => true }).start()

mount(CodeEntry, { target: document.getElementById('app')! })
